module.exports = __webpack_public_path__ + "img/exam.7a103157.svg";